import { render, staticRenderFns } from "./SubscriptionsSettings.vue?vue&type=template&id=2fe22740&scoped=true&"
import script from "./SubscriptionsSettings.vue?vue&type=script&lang=js&"
export * from "./SubscriptionsSettings.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionsSettings.vue?vue&type=style&index=0&id=2fe22740&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe22740",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fe22740')) {
      api.createRecord('2fe22740', component.options)
    } else {
      api.reload('2fe22740', component.options)
    }
    module.hot.accept("./SubscriptionsSettings.vue?vue&type=template&id=2fe22740&scoped=true&", function () {
      api.rerender('2fe22740', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/mix/SubscriptionsSettings.vue"
export default component.exports